"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
require("./TextExpander.scss");
class TextExpander {
  constructor(container) {
    this.container = container.classed('text-expander', true);
    this.initGroups();
  }
  initGroups() {
    this.title = this.container.append('div').classed('text-ex-title', true);
    const expander = this.container.append('div').classed('text-ex-expander', true);
    this.content = expander.append('div').classed('text-ex-content', true);
    this.textLess = expander.append('div').classed('text-ex-less', true).on('click', () => {
      this.collapse();
    }, {
      passive: true
    });
    this.textLess.append('div').classed('less-text', true).text('see less');
    this.textLess.append('div').classed('arrow', true);
    const summaryContainer = this.container.append('div').classed('text-ex-summary', true);
    this.summary = summaryContainer.append('span').classed('summary-content', true);
    this.textMore = summaryContainer.append('div').classed('text-ex-more', true).on('click', () => {
      this.expand();
    }, {
      passive: true
    });
    this.textMore.append('div').classed('more-text', true).text('see more');
    this.textMore.append('div').classed('arrow', true);
  }
  setTitle(title) {
    this.title.text(`${title}:`);
  }
  expand() {
    this.container.select('.text-ex-summary').style('display', 'none');
    this.container.select('.text-ex-expander').style('display', null);
  }
  collapse() {
    this.container.select('.text-ex-expander').style('display', 'none');
    this.container.select('.text-ex-summary').style('display', null);
  }
  show() {
    this.container.style('display', null);
  }
  hide() {
    this.container.style('display', 'none');
  }
}
exports.default = TextExpander;